import Section from "./Section";

export const LayoutComponents = () => {
  return (
    <div className="my-4">
      <p>Data Display Components</p>

      <Section>
        <h1>Section</h1>
      </Section>
    </div>
  );
};
